import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContentContext = createContext(null);

export const SiteContentProvider = ({ children }) => {
  const [siteContent, setSiteContent] = useState(null);
  const [siteContentLoading, setSiteContentLoading] = useState(true);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/content/public`);
      setSiteContent(response.data);
    } catch (error) {
      console.error('Failed to load site content:', error);
      setSiteContent({});
    } finally {
      setSiteContentLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const refreshContent = () => fetchContent();

  return (
    <SiteContentContext.Provider value={{ siteContent, siteContentLoading, refreshContent }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => useContext(SiteContentContext);
